import { computed, defineComponent } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import {
  isAllowedRoute,
  isEnabledRoute,
  isRouteLeafConfig,
  isVisibleRoute,
} from '@/entity-route-config';
import useSecurityStore from '@/store/security';

export default defineComponent({
  setup() {
    const route = useRoute();
    const router = useRouter();
    const security = useSecurityStore();
    const config = computed(() => {
      const config = route.meta.config;
      return isRouteLeafConfig(config) ? config : null;
    });

    if (config.value) {
      if (!isEnabledRoute(security, config.value) || !isVisibleRoute(security, config.value)) {
        router.replace({ name: '404' });
        return;
      }
      if (!isAllowedRoute(security, config.value)) {
        router.replace({ name: '403' });
        return;
      }
    }
  },
});
